import { refreshOutreachStages } from './contact-book';
import { refreshOutreaches } from './outreaches';
import { runOwnerNoteRereads } from './owner-note-refresh';

/**
 * Re-read every cache a row showing an outreach can be reading (`OWNER_NOTE_REREADS`) — the contact-book
 * stages and person reads, the bridge's `/api/outreaches` entry — plus the caller's own read. Used by the
 * "Tell {agent}" composer's re-read schedule and its unmount, and by Close, so no host can leave the rows
 * behind a dialog on a stale source. Never rejects.
 */
export function rereadAfterOwnerAction(hostRead?: () => unknown): Promise<void> {
  return runOwnerNoteRereads({ contactStages: refreshOutreachStages, outreaches: refreshOutreaches, host: hostRead });
}
